import type { FaireProductEntity } from "../../entity_types/product";

export const p_4pjuakdg8t: FaireProductEntity = {
  token: "p_4pjuakdg8t",
  type: "product",
  name: "Caramel Coffee Wax Melt",
  brandName: "The Littlest Things",
  imageUrl:
    "https://cdn.faire.com/fastly/770f058170c97b12bc1960ee2349adeca923716a9b58a2a5c39786010b0567db.png",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c69533268d4d56f38375c4baa60ce1c6d10ed00944b7c56ae30417f49c52d352.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
